import React from 'react'
import Styles from '../EmailBlock.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { Spinner } from 'common/Spinner/Spinner'

type SubjectInputProps = {
  subject: string
  onSubjectChange: (subject: string) => void
  isLoading: boolean
}

export function SubjectInput({ subject, onSubjectChange, isLoading }: SubjectInputProps) {
  return (
    <div className={Styles.formGroup}>
      <label className={Styles.label} htmlFor="subject">
        Subject Line
      </label>
      {isLoading ? (
        <div className={Styles.loadingContainer}>
          <Spinner className={Styles.spinner} />
        </div>
      ) : (
        <div className={Styles.selectWrapper}>
          <Input
            id="subject"
            name="subject"
            value={subject}
            onChange={(e) => onSubjectChange(e.target.value)}
            placeholder="Enter a subject"
            className={Styles.textInput}
            disabled={isLoading}
          />
        </div>
      )}
    </div>
  )
}
